<template>
	<ul
		class="ul--nostyling button-list grid"
		role="group"
		:aria-label="ariaLabelFilterOnYears"
	>
		<li class="col-auto" v-for="filter in filters" :key="filter">
			<label class="button-switch">
				<input
					type="checkbox"
					:value="parseInt(filter)"
					v-model="activeFilters"
					@change="onCheckboxChange($event)"
				/>
				<span class="button-switch__button">{{ filter }}</span>
			</label>
		</li>
	</ul>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  chosenFilters: Array,
  filters: Array,
  ariaLabelFilterOnYears: String
});

const emit = defineEmits(['update']);

const activeFilters = ref([]);

onMounted(() => {
  activeFilters.value = props.chosenFilters;
});

const onCheckboxChange = (evt) => {
  emit('update', activeFilters.value);
};
</script>
